import Vue          from 'vue';
import VueCarousel  from 'vue-carousel';
import store        from './store';
import components   from './components';
import filters      from './filters';

import './scss/main.scss';
import './js/scroll.js';
import './js/serializeObject.js';

import bootbox from 'bootbox';
import request from "./store/utils/request";

import lazysizes from "lazysizes";

Vue.use(VueCarousel);

// Register filters globally
for (const filter in filters) {
  if ({}.hasOwnProperty.call(filters, filter)) {
    Vue.filter(filter, filters[filter]);
  }
}

// Register components globally
for (const component in components) {
  if ({}.hasOwnProperty.call(components, component)) {
    Vue.component(component, components[component]);
  }
}


const app = new Vue({
  name: 'App',
  el: 'main',
  delimiters: ['${', '}'],
  store,
  components
});

export {
  app,
  store,
  bootbox
};


// Tag Commander
$('.zoneNewsletter form button').click(function(e) {
  tc_events_20(this,"conf_news",{'user_email':$(this).closest('form').find('input').val()});
});

$('body').on('click', 'a.show-cart', function(e) {
  var data = {'user_id': $('body').data('user-id'), 'user_email': $('body').data('user-email')};
  tc_events_20(this,"conf_insc_news", data);
});

$(document).ready(() => {
    togglerMobileMenu();
    firstLevelDropdownMenuSetUp();

    var products = new Bloodhound({
        datumTokenizer: function(datum) {
            return Bloodhound.tokenizers.whitespace(datum.value);
        },
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            wildcard: '%QUERY',
            url : '/autocomplete?q=%QUERY',
            rateLimitWait: 1000,
            transform: function(response) {
                return $.map(response.products.product, function(product) {
                    return {
                        value: product.title,
                        type: response.type,
                        url: product.slug,
                        id: product.id,
                    };
                });
            }
        }
    });

    var categories = new Bloodhound({
        datumTokenizer: function(datum) {
            return Bloodhound.tokenizers.whitespace(datum.value);
        },
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            wildcard: '%QUERY',
            url : '/autocomplete?q=%QUERY',
            rateLimitWait: 1000,
            transform: function(response) {
                return $.map(response.products.category, function(category) {
                    return {
                        value: category.categoryTitle,
                        url: category.categoryFullSlug,
                        id: category.categoryId,
                        type: 'category',
                    };
                });
            }
        }
    });

    $('#formSearch .typeahead').typeahead({
            hint: true,
            highlight: true,
            minLength: 2
        },
        {
            name: 'categories',
            display: 'value',
            source: categories,
            limit:25,
            templates: {
                header: '<div class="tt-category">Catégories</div>',
                suggestion: function(data) {
                    return '<div><a href="' + Routing.generate('site_product_category', { 'id' : data.id, 'slug' : data.url }) + '">' + data.value + '</a></div>';
                },
                notFound: '<div class="tt-no-result"><em>Pas de résultat</em></div>',
            }
        },
        {
            name: 'products',
            display: 'value',
            source: products,
            limit:25,
            templates: {
                header: function(data) {
                    if (data.suggestions[0].type === 'suggestion') {
                        return '<div class="tt-category">Suggestions</div>'
                    } else {
                        return '<div class="tt-category">Produits</div>'
                    }
                },
                suggestion: function(data) {
                    return '<div><a href="' + Routing.generate('site_product_show', { 'id' : data.id, 'slug' : data.url }) + '">' + data.value + '</a></div>';
                },
            }
        });

    $('#formSearch .typeahead').on('typeahead:render', function(event, selection) {
        if($(".tt-suggestion").length){
            $(".tt-no-result").hide();
        }
    });

    $('#formSearch .typeahead').on('typeahead:selected', function(event, selection) {
        if ('category' === selection.type) {
            document.location = Routing.generate('site_product_category', { 'id' : selection.id, 'slug' : selection.url });
        } else {
            document.location = Routing.generate('site_product_show', { 'id' : selection.id, 'slug' : selection.url });
        }
    });

  let hasHomeInput = false;
  let checkCouponCodeTimeoutID = null;

  function loadWidget() {
    $('#widget-coupon-submit').attr('disabled', 'disabled');
    $('#widget-coupon-submit').html('<i class="fa fa-spinner fa-spin"></i>');
    $('#widget-coupon-more-fields').html('');
  }

  function removeWidget() {
    $('#widget-coupon-submit').removeAttr('disabled');
    $('#widget-coupon-submit').html('OK');
  }

  function clearTimeoutCheckCoupon() {
    clearTimeout(checkCouponCodeTimeoutID);
    checkCouponCodeTimeoutID = null;
  }

  function checkCouponCode(couponCode) {
    request
      .get(Routing.generate('site_enter_promotion_home', {'coupon_code': couponCode}))
      .then(function(response) {
        $('#widget-coupon-more-fields').html('');

        hasHomeInput = response.data.has_home_input;

        if (hasHomeInput) {
          $('#widget-coupon-more-fields').append('<input style="margin-top: 10px;" type="text" name="code_home" class="form-control" placeholder="Code client">');
        }

        clearTimeoutCheckCoupon();
        removeWidget();

        $('#advantageCodeInput').val(response.data.code);
      });
  }

  $('#advantageCodeInput').on('input', function(event) {
    const couponCode = $(this).val();

    if ('' === couponCode) {
      clearTimeoutCheckCoupon();
      removeWidget();
      return;
    }

    loadWidget();

    if (null !== checkCouponCodeTimeoutID) {
      clearTimeoutCheckCoupon();
    }

    checkCouponCodeTimeoutID = setTimeout(() => checkCouponCode(couponCode), 2000);
  });

    // set tracking data sur button coupon avantage
    if ($('.js-trk-promo-code').length > 0) {
      const input = document.getElementById('advantageCodeInput');
      const button = document.getElementById('widget-coupon-submit');

      function updateDataTrkCode() {
          const value = input.value;
          button.setAttribute('data-trk-promo-code', value);
      };

      input.oninput = updateDataTrkCode;
      updateDataTrkCode();
    }

    // set tracking data sur button coupon avantage courrier sur /mon-code-promo
    if ($('.js-trk-print-offer').length > 0) {
      const inputPrint = document.getElementById('advantageCodePrintInput');
      const buttonPrint = document.getElementById('trk-print-offer');

      function updateDataTrkPrint() {
          const valuePrint = inputPrint.value;
          buttonPrint.setAttribute('data-trk-print-offer', valuePrint);
      };

      inputPrint.oninput = updateDataTrkPrint;
      updateDataTrkPrint();
    }
});

const firstLevelDropdownMenuSetUp = () => {
  const firstLevelDropdownMenu = document.querySelectorAll('.first-level');
  const secondLevelDropdownMenu = document.querySelectorAll('.second-level');

  const dropdown = elem => {
    if (elem.getAttribute('data-entries') !== '0') {
      if (elem.nextElementSibling.classList.contains('show')) {
        elem.querySelector('i').classList.remove('fa-angle-up');
        elem.querySelector('i').classList.add('fa-angle-down');
        elem.nextElementSibling.classList.remove('show');
      } else {
        elem.querySelector('i').classList.remove('fa-angle-down');
        elem.querySelector('i').classList.add('fa-angle-up');
        elem.nextElementSibling.classList.add('show');
      }
    }
  };
  const slideRight = elem => {
    if (!elem.getAttribute('data-setup-action') || elem.getAttribute('data-setup-action') !== true) {
      elem.nextElementSibling.querySelector('.previous-first-level').addEventListener('click', () => {
        slideRight(elem);
      });
      elem.setAttribute('data-setup-action', 'true')
    }

    if (elem.nextElementSibling.classList.contains('show')) {
      elem.nextElementSibling.classList.remove('show');
    } else {
      elem.nextElementSibling.classList.add('show');
    }
  };

  for (let i = 0; i < firstLevelDropdownMenu.length; i++) {
    firstLevelDropdownMenu[i].addEventListener('click', () => {
      slideRight(firstLevelDropdownMenu[i]);
    });
  }
  for (let i = 0; i < secondLevelDropdownMenu.length; i++) {
    secondLevelDropdownMenu[i].addEventListener('click', () => {
      dropdown(secondLevelDropdownMenu[i]);
    });
  }
};

const togglerMobileMenu = () => {
  const toggler = document.querySelector('.navbar-toggler');
  const maintContent = document.querySelector('#mainContent');
  const mainFooter = document.querySelector('#mainFooter');
  const firstLevelDropdownMenu = document.querySelectorAll('.first-level');
  const secondLevelDropdownMenu = document.querySelectorAll('.second-level');

  toggler.addEventListener('click', () => {
    if (toggler.classList.contains('collapsed')) {
      maintContent.classList.add('d-none');
      mainFooter.classList.add('d-none');
    } else {
      maintContent.classList.remove('d-none');
      mainFooter.classList.remove('d-none');

      for (let i = 0; i < firstLevelDropdownMenu.length; i++) {
        firstLevelDropdownMenu[i].nextElementSibling.classList.remove('show');
      }
      for (let i = 0; i < secondLevelDropdownMenu.length; i++) {
        let carret = secondLevelDropdownMenu[i].querySelector('i');

        secondLevelDropdownMenu[i].nextElementSibling.classList.remove('show');
        if (carret) {
          carret.classList.remove('fa-angle-up');
          carret.classList.add('fa-angle-down');
        }
      }
    }
  });
};



// WEBPACK FOOTER //
// ./src/SiteBundle/Resources/assets/app.js